import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { IStory } from 'src/app/classes/def/core/story';
import { EStoryLocationDoneFlag } from 'src/app/classes/def/nav-params/story';
import { IAppLocation } from 'src/app/classes/def/places/app-location';

@Component({
  selector: 'location-dots-v',
  templateUrl: './location-dots-v.component.html',
  styleUrls: ['./location-dots-v.component.scss'],
})
export class LocationDotsVComponent implements OnInit, OnDestroy {

  color: string = "light";

  @Input()
  data: IAppLocation[];

  @Input()
  story: IStory;

  @Input()
  dark: boolean;

  @Input()
  useDefaultPhotos: boolean;

  @Output()
  select: EventEmitter<any> = new EventEmitter();

  constructor() {

  }

  isLast(index: number) {
    if (this.data) {
      if (index < this.data.length - 1) {
        return false;
      }
      return true;
    }
    return false;
  }

  getClassV2(aloc: IAppLocation) {
    let css = "multistep-progress-2-v-item";
    if (aloc && aloc.loc && aloc.loc.merged) {
      if (aloc.loc.merged.googleId) {
        css += " opened";
      }
      if (aloc.dispDone) {
        css += " active";
      }
      if (aloc.loc.merged.done === EStoryLocationDoneFlag.done) {
        css += " done";
      }
    }
    return css;
  }

  isDone(item: IAppLocation) {
    if (item && item.loc && item.loc.merged) {
      return item.loc.merged.googleId && ((item.loc.merged.done === EStoryLocationDoneFlag.done) || item.dispDone);
    }
    return false;
  }

  clicked(index: number) {
    this.select.emit([index]);
  }

  ngOnInit() {
    if (this.dark) {
      this.color = "primary";
    }
  }

  ngOnDestroy() {

  }


}
